'use strict';

var Marionette = require('backbone.marionette');
var _ = require('underscore');
var $ = require('jquery');
var moment = require('moment-timezone');

export default Marionette.View.extend({

  template: require('./templates/summary.hbs'),
  className: 'appointment-summary',
  defaults: {
    showStaff: window.SETTINGS.show_staff_picker || window.SETTINGS.show_staff_assigned,
  },

  initialize: function (options) {
    this.clearModal();
    this.options = _.extend({}, this.defaults, this.options);
  },

  serializeData: function () {
    var json = this.model.toJSON();

    var location = this.model.location;
    if (location) {
      json.location = location.toJSON();
    }

    if (window.localStorage.getItem('timezone')) {
      var format = 'YYYY-MM-DD HH:mm:ss';
      var start = json.start;

      if (typeof start === 'string') {
        start = moment.tz(start, location.get('timezone'));
      }

      var startWithTimezone = start.clone().tz(window.localStorage.getItem('timezone'));

      json.start = startWithTimezone.format(format);
      json.timezone = window.localStorage.getItem('timezone');
      json.timezone_abbr = startWithTimezone.zoneAbbr();
    }

    if (this.model.hasServices()) {
      json.services = _.map(this.model.getServices(), function (service) {
        var serviceJson = service.toJSON();
        serviceJson.currency = window.SETTINGS.currency;
        serviceJson.notFree = service.showPrice();
        return serviceJson;
      });
    }

    var staff = this.model.getStaff();
    if (this.options.showStaff && staff) {
      json.staff = staff.toJSON();
    } else {
      delete json.staff;
    }

    return json;
  },

  /**
   * Clear any existing data in the modal before displaying.
   *
   * @returns {jQuery}
   */
  clearModal: function () {
    return $('#modal .modal-body').empty();
  }
});
